import { RoutePermittedRole } from "shared/constants/AppConst";
import Category from "./category";
export const categoryConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/pricePlanCategory",
    element: <Category />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/pricePlanCategory/category",
    element: <Category />,
  },
];


